import { render, staticRenderFns } from "./chartLevel.vue?vue&type=template&id=b2b052ba&scoped=true&"
import script from "./chartLevel.vue?vue&type=script&lang=js&"
export * from "./chartLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b052ba",
  null
  
)

export default component.exports